import React from 'react';

const StatTile = ({ label, value, accent, onClick }) => (
  <div
    className={`admin-stat-box ${onClick ? 'admin-stat-clickable' : ''}`}
    onClick={onClick}
  >
    <div className="stat-label">{label}</div>
    <div className="stat-value" style={accent ? { color: accent } : undefined}>{value}</div>
  </div>
);

export default StatTile;
